/* eslint-disable no-param-reassign, max-params */
const initialState = {};

const deliveryModule = {
  namespaced: true,

  state() {
    return { ...initialState };
  },

  getters: {},

  mutations: {},

  actions: {}
};

export default deliveryModule;
